import { Preferences } from '@capacitor/preferences';

export const storage = {
  async set(key, value) {
    await Preferences.set({ key, value: JSON.stringify(value) });
  },
  async get(key) {
    const { value } = await Preferences.get({ key });
    if (!value || value === 'undefined' || value === 'null') {
      return null;
    }
    try {
      return JSON.parse(value);
    } catch (e) {
      console.warn(`Error parsing storage value for key ${key}:`, e);
      return null;
    }
  },
  async remove(key) {
    await Preferences.remove({ key });
  }
};
